import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../context/AuthContext";
import { MdClose } from "../utils/Icons";

// Imports
import TitleText from "./TitleText";

const AuthComponent = () => {
	const {
		setIsAuth,
		userRegisterData,
		setUserRegisterData,
		handleUserRegister,
		userLoginData,
		setUserLoginData,
		handleUserLogin,
		handleTCPP,
		handleTC,
		userForgotPasswordData,
		setUserForgotPasswordData,
		handleForgotPassword,
	} = useAuthContext();
	const [isSignup, setIsSignup] = useState(false);
	const [isForgotPassword, setIsForgotPassword] = useState(false);
	const [showPassword, setShowPasword] = useState(false);
	const [showConfirmPassword, setShowConfirmPasword] = useState(false);
	const [userAgreed, setUserAgreed] = useState(true);
	const [registerErrors, setRegisterErrors] = useState({});

	const handleShowPassword = () => {
		setShowPasword((prev) => !prev);
	};

	const handleShowConfirmPassword = () => {
		setShowConfirmPasword((prev) => !prev);
	};

	const handleUserAgreed = () => {
		setUserAgreed((prev) => !prev);
	};

	const handleRegisterChange = (e) => {
		const { name, value } = e.target;
		setUserRegisterData((prevState) => ({
			...prevState,
			[name]: value,
		}));
	};

	const handleLoginChange = (e) => {
		const { name, value } = e.target;
		setUserLoginData((prevData) => ({
			...prevData,
			[name]: value,
		}));
	};

	const handleForgotPasswordChange = (e) => {
		const { name, value } = e.target;
		setUserForgotPasswordData((prevState) => ({
			...prevState,
			[name]: value,
		}));
	};
	const validatePassword = (password) => {
		const errors = [];
		if (!/[A-Z]/.test(password))
			errors.push("Must contain at least one uppercase letter");
		if (!/[0-9]/.test(password))
			errors.push("Must contain at least one number");
		if (!/[!@#$%^&*]/.test(password))
			errors.push("Must contain at least one special character");
		if (password.length < 8) errors.push("Must be at least 8 characters long");
		return errors;
	};

	const [isLoading, setIsLoading] = useState(false);

	const startAnimation = () => {
		setIsLoading(true);
		return new Promise((resolve) => {
			setTimeout(() => {
				resolve();
			}, 500);
		});
	};

	const resetAnimation = () => {
		return new Promise((resolve) => {
			setIsLoading(false);
			setTimeout(() => {
				resolve();
			}, 500);
		});
	};

	const handleLoginClick = async () => {
		await startAnimation();
		await handleUserLogin();
		await resetAnimation();
	};

	// const handleUserRegisterClick = async () => {
	// 	await startAnimation();
	// 	await handleUserRegister();
	// 	await resetAnimation();
	// };

	const handleUserRegisterClick = async () => {
		setRegisterErrors({}); // Clear previous errors

		// Client-side password validation
		const pwdErrors = validatePassword(userRegisterData.password);
		if (pwdErrors.length > 0) {
			setRegisterErrors({ password: pwdErrors });
			return;
		}

		// Confirm password match
		if (userRegisterData.password !== userRegisterData.confirmPassword) {
			setRegisterErrors({ confirmPassword: ["Passwords do not match"] });
			return;
		}

		// Check user agreed to terms
		if (!userAgreed) {
			setRegisterErrors({ terms: ["You must agree to Terms & Conditions"] });
			return;
		}

		await startAnimation();

		try {
			await handleUserRegister();
			setRegisterErrors({}); // Clear errors on success
		} catch (error) {
			if (error.response?.data) {
				setRegisterErrors(
					error.response.data.errors || { general: error.response.data.message }
				);
			} else {
				setRegisterErrors({
					general: "Registration failed. Please try again.",
				});
			}
		}

		await resetAnimation();
	};

	const handleForgotPasswordClick = async () => {
		await startAnimation();
		await handleForgotPassword();
		await resetAnimation();
	};

	return (
		<div className='w-screen h-screen bg-black/50 flex justify-center items-center p-[3%] fixed left-0 top-0 right-0 bottom-0 z-50'>
			<div className='w-full lg:w-[500px] h-fit bg-whiteColor border rounded-xl lg:rounded-3xl shadow pt-[2%] lg:pt-[1%] pb-[2%] px-[2%] lg:px-[1%] animate-slideTopToBottom'>
				<div className='w-full h-fit flex justify-end items-center'>
					<button
						className='text-lg text-textPrimaryColor'
						onClick={() => setIsAuth(false)}>
						<MdClose />
					</button>
				</div>

				{/* Signup window */}
				{isSignup && !isForgotPassword && (
					<div className='w-full h-fit flex flex-col justify-center items-center px-[5%]'>
						<TitleText text='Create Account' />
						<p className='font-medium text-base text-textSecondaryColor text-center mt-4'>
							Enter your details to create a
						</p>
						<p className='font-medium text-base text-textSecondaryColor text-center mb-8'>
							new account
						</p>
						<input
							type='text'
							name='name'
							value={userRegisterData.name}
							onChange={handleRegisterChange}
							placeholder='Full Name'
							required
							maxLength={25}
							className='w-full h-12 border-2 rounded-xl px-[3%] placeholder:text-sm font-normal text-sm text-textPrimaryColor outline-none mb-4'
						/>
						<input
							type='email'
							name='email'
							value={userRegisterData.email}
							onChange={handleRegisterChange}
							placeholder='Email Address'
							required
							maxLength={50}
							className='w-full h-12 border-2 rounded-xl px-[3%] placeholder:text-sm font-normal text-sm text-textPrimaryColor outline-none mb-4'
						/>
						{registerErrors.email && (
							<p className='text-red-500 text-xs mt-1'>
								{registerErrors.email}
							</p>
						)}

						<input
							type='number'
							name='contact'
							value={userRegisterData.contact}
							placeholder='Phone number'
							onChange={(e) => {
								const value = e.target.value;
								if (value.length <= 10) {
									handleRegisterChange(e);
								}
							}}
							max={9999999999}
							onKeyDown={(e)=> {
								if(['e', 'E', '+', '-', '.'].includes(e.key)){
									e.preventDefault();
								}
							}}
							className='w-full h-12 border-2 rounded-xl px-[3%] placeholder:text-sm font-normal text-sm text-textPrimaryColor outline-none mb-4'
						/>
						<div className='w-full h-fit mb-4 relative'>
							<input
								type={showPassword ? "text" : "password"}
								name='password'
								value={userRegisterData.password}
								onChange={handleRegisterChange}
								placeholder='Password'
								required
								className='w-full h-12 border-2 rounded-xl px-[3%] placeholder:text-sm font-normal text-sm text-textPrimaryColor outline-none'
							/>
							<button
								className='font-normal text-xs text-textPrimaryColor underline absolute right-[4%] top-1/2 transform -translate-y-1/2'
								onClick={handleShowPassword}>
								{showPassword ? "Hide" : "Show"}
							</button>
						</div>
						{registerErrors.password && (
							<ul className='text-red-500 text-xs mt-1 mb-1 list-disc '>
								{registerErrors.password.map((err, i) => (
									<li key={i} className='mb-1'>
										{err}
									</li>
								))}
							</ul>
						)}

						<div className='w-full h-fit mb-2 relative'>
							<input
								type={showConfirmPassword ? "text" : "password"}
								name='confirmPassword'
								value={userRegisterData.confirmPassword}
								onChange={handleRegisterChange}
								placeholder='Confirm Password'
								required
								className='w-full h-12 border-2 rounded-xl px-[3%] placeholder:text-sm font-normal text-sm text-textPrimaryColor outline-none'
							/>
							<button
								className='font-normal text-xs text-textPrimaryColor underline absolute right-[4%] top-1/2 transform -translate-y-1/2'
								onClick={handleShowConfirmPassword}>
								{showConfirmPassword ? "Hide" : "Show"}
							</button>
						</div>
						{registerErrors.confirmPassword && (
							<p className='text-red-500 text-xs mt-1 mb-1'>
								{registerErrors.confirmPassword}
							</p>
						)}

						<div className='w-full h-fit flex items-center mb-10 space-x-2'>
							<input
								type='checkbox'
								checked={userAgreed}
								onChange={handleUserAgreed}
							/>
							<p className='font-normal text-xs text-textSecondaryColor'>
								I agree to{" "}
								<span
									className='font-medium text-primaryColor cursor-pointer'
									onClick={handleTC}>
									Terms & Condition
								</span>{" "}
								and{" "}
								<span
									className='font-medium text-primaryColor cursor-pointer'
									onClick={handleTCPP}>
									Privacy Policy
								</span>
							</p>
						</div>
						{registerErrors.general && (
							<p className='text-red-600 text-sm mb-4'>
								{registerErrors.general}
							</p>
						)}

						<button
							disabled={
								!(
									userAgreed &&
									userRegisterData.name &&
									userRegisterData.email &&
									userRegisterData.contact &&
									userRegisterData.password &&
									userRegisterData.confirmPassword
								)
							}
							className={`w-full ${
								userAgreed
									? "bg-gradient-to-r from-[#0047AF] to-[#1A67D8]"
									: "bg-accentColor"
							} rounded-3xl font-normal text-sm text-whiteColor py-3 mb-6 transition-all duration-500 ease-in-out
              ${
								isLoading
									? "w-12 h-12 opacity-70 rounded-full p-0"
									: "w-full opacity-100"
							}
              `}
							onClick={handleUserRegisterClick}>
							{isLoading ? (
								<div className='flex items-center justify-center w-full h-full'>
									<div className='w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin'></div>
								</div>
							) : (
								"Create Account"
							)}
						</button>
						<p className='font-normal text-sm text-textSecondaryColor'>
							Already have an account?{" "}
							<span
								className='font-semibold text-primaryColor cursor-pointer'
								onClick={() => setIsSignup(false)}>
								Login
							</span>
						</p>
					</div>
				)}

				{/* Login window */}
				{!isSignup && !isForgotPassword && (
					<div className='w-full h-fit flex flex-col justify-center items-center px-[5%]'>
						<TitleText text='Login' />
						<p className='font-medium text-base text-textSecondaryColor text-center mt-4'>
							Enter your details to get sign in to
						</p>
						<p className='font-medium text-base text-textSecondaryColor text-center mb-8'>
							your account
						</p>
						<input
							type='email'
							name='email'
							value={userLoginData.email}
							onChange={handleLoginChange}
							placeholder='Email Address'
							required
							maxLength={50}
							className='w-full h-12 border-2 rounded-xl px-[3%] placeholder:text-sm font-normal text-sm text-textPrimaryColor outline-none mb-4'
						/>
						<div className='w-full h-fit mb-2 relative'>
							<input
								type={showPassword ? "text" : "password"}
								name='password'
								value={userLoginData.password}
								onChange={handleLoginChange}
								placeholder='Password'
								required
								className='w-full h-12 border-2 rounded-xl px-[3%] placeholder:text-sm font-normal text-sm text-textPrimaryColor outline-none'
							/>
							<button
								className='font-normal text-xs text-textPrimaryColor underline absolute right-[4%] top-1/2 transform -translate-y-1/2'
								onClick={handleShowPassword}>
								{showPassword ? "Hide" : "Show"}
							</button>
						</div>
						<div className='w-full h-fit mb-10'>
							<button
								className='font-normal text-sm text-primaryColor underline'
								onClick={() => setIsForgotPassword(true)}>
								Forgot Password
							</button>
						</div>
						<button
							disabled={
								userLoginData.email.length === 0 &&
								userLoginData.password.length === 0
							}
							className={`
              bg-gradient-to-r from-[#0047AF] to-[#1A67D8] rounded-3xl font-normal text-sm text-whiteColor py-3 mb-6
              transition-all duration-500 ease-in-out
              ${
								isLoading
									? "w-12 h-12 opacity-70 rounded-full p-0"
									: "w-full opacity-100"
							}
          
            `}
							onClick={handleLoginClick}>
							{isLoading ? (
								<div className='flex items-center justify-center w-full h-full'>
									<div className='w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin'></div>
								</div>
							) : (
								"Login"
							)}
						</button>
						<p className='font-normal text-sm text-textSecondaryColor'>
							Don’t have an account?{" "}
							<span
								className='font-semibold text-primaryColor cursor-pointer'
								onClick={() => setIsSignup(true)}>
								Create Account
							</span>
						</p>
					</div>
				)}

				{/* Forgot password window */}
				{isForgotPassword && (
					<div className='w-full h-fit flex flex-col justify-center items-center px-[5%]'>
						<TitleText text='Forgot Password' />
						<p className='font-medium text-base text-textSecondaryColor text-center mt-4 mb-8'>
							Enter your email to reset your password.
						</p>
						<input
							type='email'
							name='email'
							value={userForgotPasswordData.email}
							onChange={handleForgotPasswordChange}
							placeholder='Email Address'
							required
							maxLength={50}
							className='w-full h-12 border-2 rounded-xl px-[3%] placeholder:text-sm font-normal text-sm text-textPrimaryColor outline-none mb-10'
						/>
						<button
							disabled={userForgotPasswordData.email.length === 0}
							className={`
              w-full bg-gradient-to-r from-[#0047AF] to-[#1A67D8] rounded-3xl font-normal text-sm text-whiteColor py-3
              transition-all duration-500 ease-in-out
              ${
								isLoading
									? "w-12 h-12 opacity-70 rounded-full p-0"
									: "w-full opacity-100"
							}
              `}
							onClick={handleForgotPasswordClick}>
							{isLoading ? (
								<div className='flex items-center justify-center w-full h-full'>
									<div className='w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin'></div>
								</div>
							) : (
								" Reset Password"
							)}
						</button>
					</div>
				)}
			</div>
		</div>
	);
};

export default AuthComponent;
